
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type collaborationUpdateInput = {
  action: Action,
  collaborationId: string,
  description?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  objective?: string | null,
  orgType: string,
  ownerDatasets?: Array< DatasetInput > | null,
  partnerDatasets?: Array< DatasetInput > | null,
  partnerEmail?: Array< string > | null,
  partnerInviteMessage?: string | null,
  partnerOrgType?: string | null,
  status?: CollaborationStatus | null,
};

export enum Action {
  CLOSE = "CLOSE",
  CREATE = "CREATE",
  DELETE = "DELETE",
  GET_COLLABORATION = "GET_COLLABORATION",
  LIST = "LIST",
  LIST_EMAIL = "LIST_EMAIL",
  ON_HOLD = "ON_HOLD",
  RESUME = "RESUME",
  SEND_INVITE = "SEND_INVITE",
  UPDATE = "UPDATE",
  UPDATE_DATASET = "UPDATE_DATASET",
}


export type DatasetInput = {
  dataConnectionId: string,
  dataConnectionName: string,
  schemaName: string,
  tableName: string,
};

export enum CollaborationStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  DRAFT = "DRAFT",
  INVITATION_DECLINED = "INVITATION_DECLINED",
  ON_HOLD = "ON_HOLD",
  PENDING = "PENDING",
}


export type CollaborationResponse = {
  __typename: "CollaborationResponse",
  data?: Collaboration | null,
  message?: string | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type Collaboration = {
  __typename: "Collaboration",
  collaborationId: string,
  createdAt?: string | null,
  createdBy?: string | null,
  description: string,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name: string,
  objective: string,
  orgType: string,
  ownerDatasets?:  Array<Dataset > | null,
  partnerDatasets?:  Array<Dataset > | null,
  partnerEmail?: Array< string > | null,
  partnerInviteMessage?: string | null,
  partnerOrgType?: string | null,
  status: CollaborationStatus,
};

export type Dataset = {
  __typename: "Dataset",
  dataConnectionId: string,
  dataConnectionName: string,
  schemaName: string,
  tableName: string,
};

export type ApproveExportAudienceInput = {
  approvalStatus: ApprovalStatus,
  approvedBy: string,
  engagement: string,
  exportId: string,
  rejectReason?: string | null,
};

export enum ApprovalStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}


export type ExportAudience = {
  __typename: "ExportAudience",
  approvalStatus?: ApprovalStatus | null,
  approvedBy?: string | null,
  attributesMapping?: string | null,
  audienceFrom?: AudienceType | null,
  channelId?: string | null,
  engagement: string,
  expireAt?: string | null,
  exportId: string,
  exportStatus?: ExportStatus | null,
  exportedAt?: string | null,
  exportedBy?: string | null,
  fileType?: FileType | null,
  folderPath?: string | null,
  orgType?: string | null,
  queryId?: string | null,
  queryName?: string | null,
  rejectReason?: string | null,
  targetChannel?: AllowedChannel | null,
};

export enum AudienceType {
  LOOKALIKE_MODEL = "LOOKALIKE_MODEL",
  QUERY = "QUERY",
}


export enum ExportStatus {
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  SUBMISSION_FAILED = "SUBMISSION_FAILED",
  SUBMITTED = "SUBMITTED",
  SUCCESS = "SUCCESS",
}


export enum FileType {
  CSV = "CSV",
  PARQUET = "PARQUET",
}


export enum AllowedChannel {
  GOOGLE = "GOOGLE",
  META = "META",
  S3 = "S3",
}


export type ApproveQueryInput = {
  approvalStatus: ApprovalStatus,
  approvedBy: string,
  engagement: string,
  lastModifiedBy: string,
  queryId: string,
  rejectReason?: string | null,
};

export type QueryRecord = {
  __typename: "QueryRecord",
  CSVKey?: string | null,
  approvalStatus?: ApprovalStatus | null,
  approvedBy?: string | null,
  athenaExecutionId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  description?: string | null,
  engagement: string,
  executionDuration?: number | null,
  executionEndTime?: string | null,
  executionStartTime?: string | null,
  executionStatus?: ExecutionStatus | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  metadata?: string | null,
  metadataKey?: string | null,
  name?: string | null,
  orgType?: string | null,
  query?: string | null,
  queryId: string,
  rejectReason?: string | null,
  syntheticResult?: SyntheticResultStatus | null,
  type?: QueryType | null,
  validationLogs?: string | null,
  validationStatus?: Status | null,
};

export enum ExecutionStatus {
  CANCELLED = "CANCELLED",
  FAIL = "FAIL",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export enum SyntheticResultStatus {
  CLEANED = "CLEANED",
  FAIL = "FAIL",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export enum QueryType {
  AGGREGATE = "AGGREGATE",
  LIST = "LIST",
}


export enum Status {
  FAIL = "FAIL",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export type QueryStatusResponse = {
  __typename: "QueryStatusResponse",
  message?: string | null,
};

export type SyntheticDataGenerationInput = {
  action: SyntheticActions,
  engagement: string,
};

export enum SyntheticActions {
  CLEANUP_DATA = "CLEANUP_DATA",
  CLEANUP_RESULT = "CLEANUP_RESULT",
  GENERATE_DATA = "GENERATE_DATA",
  GENERATE_RESULT = "GENERATE_RESULT",
}


export type SyntheticDataGenerationResponse = {
  __typename: "SyntheticDataGenerationResponse",
  message: string,
  statusCode: number,
  success: boolean,
};

export type SyntheticResultGenerationInput = {
  action: SyntheticActions,
  engagement: string,
  queryId: string,
};

export type ActivationChannelInput = {
  awsRegion?: string | null,
  bucketName?: string | null,
  channelId?: string | null,
  channelSecrets?: string | null,
  channelType?: ChannelType | null,
  connectionStatus?: ConnectionStatus | null,
  createdBy?: string | null,
  description?: string | null,
  engagement: string,
  iamRoleArn?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
};

export enum ChannelType {
  GOOGLE = "GOOGLE",
  META = "META",
  S3 = "S3",
}


export enum ConnectionStatus {
  ACTIVE = "ACTIVE",
  FAIL = "FAIL",
  INACTIVE = "INACTIVE",
  NOT_VERIFIED = "NOT_VERIFIED",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}


export type ActivationChannel = {
  __typename: "ActivationChannel",
  awsRegion?: string | null,
  bucketName?: string | null,
  channelId: string,
  channelType?: ChannelType | null,
  connectionStatus?: ConnectionStatus | null,
  createdAt?: string | null,
  createdBy?: string | null,
  description?: string | null,
  engagement: string,
  iamRoleArn?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
};

export type SaveChartInput = {
  athenaExecutionId: string,
  chartId: string,
  chartType: ChartType,
  chartsImageUrl?: string | null,
  config?: string | null,
  createdBy?: string | null,
  description?: string | null,
  engagement: string,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
  queryId: string,
};

export enum ChartType {
  BAR = "BAR",
  GEO = "GEO",
  LINE = "LINE",
  PIE = "PIE",
  SCATTER = "SCATTER",
}


export type ChartMetadata = {
  __typename: "ChartMetadata",
  athenaExecutionId?: string | null,
  chartId: string,
  chartType: ChartType,
  chartsImageUrl?: string | null,
  config?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  dashboardIds?: Array< string > | null,
  description?: string | null,
  engagement: string,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
  queryId?: string | null,
};

export type collaborationCreateInput = {
  action: Action,
  createdBy: string,
  description: string,
  name: string,
  objective: string,
  orgType: string,
  ownerDatasets?: Array< DatasetInput > | null,
  partnerDatasets?: Array< DatasetInput > | null,
  partnerEmail?: Array< string > | null,
  partnerInviteMessage?: string | null,
  partnerOrgType?: string | null,
  status: CollaborationStatus,
};

export type SaveDashboardInput = {
  chartIds?: Array< string > | null,
  createdBy?: string | null,
  dashboardId: string,
  dashboardImageUrl?: string | null,
  description?: string | null,
  engagement: string,
  lastModifiedBy?: string | null,
  layout?: string | null,
  name?: string | null,
  orgType?: string | null,
};

export type DashboardMetadata = {
  __typename: "DashboardMetadata",
  chartIds?: Array< string > | null,
  createdAt?: string | null,
  createdBy?: string | null,
  dashboardId: string,
  dashboardImageUrl?: string | null,
  description?: string | null,
  engagement: string,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  layout?: string | null,
  name?: string | null,
  orgType?: string | null,
};

export type CreateEngagementInput = {
  collaborationId: string,
  orgName: string,
};

export type CreateEngagementResponse = {
  __typename: "CreateEngagementResponse",
  message: string,
  statusCode: number,
  success?: boolean | null,
};

export type CreateModelInput = {
  athenaExecutionId: string,
  createdBy?: string | null,
  engagement: string,
  lookalikeNumber?: number | null,
  modelId: string,
  modelType?: ModelType | null,
  name?: string | null,
  orgType?: string | null,
  parentId?: string | null,
  queryId: string,
  queryName?: string | null,
  seedAudienceSize?: number | null,
  status?: ModelStatus | null,
};

export enum ModelType {
  BASE = "BASE",
  LOOKALIKE = "LOOKALIKE",
}


export enum ModelStatus {
  FAIL = "FAIL",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}


export type Response = {
  __typename: "Response",
  data?: Model | null,
  statusCode?: number | null,
  statusMessage?: string | null,
  success: boolean,
};

export type Model = {
  __typename: "Model",
  athenaExecutionId: string,
  createdAt?: string | null,
  createdBy?: string | null,
  engagement: string,
  images?: Array< string > | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  lookalikeNumber?: number | null,
  maxLookalikeNumber?: number | null,
  metadata?: string | null,
  modelId: string,
  modelType?: ModelType | null,
  name?: string | null,
  orgType?: string | null,
  parentId?: string | null,
  queryId: string,
  queryName?: string | null,
  seedAudienceSize?: number | null,
  status?: ModelStatus | null,
};

export type CreateNewEngagementInput = {
  orgType1: string,
  orgType2: string,
  ownerDatasets?: Array< DatsetInput > | null,
  partnerDatasets?: Array< DatsetInput > | null,
};

export type DatsetInput = {
  dataConnectionId: string,
  database_name: string,
  datasource_name: string,
  table_name: string,
};

export type OrganizationInput = {
  isDatabricksConnectionAllowed?: boolean | null,
  orgName: string,
  orgType: OrgType,
  s3Bucket?: string | null,
};

export enum OrgType {
  CLUB = "CLUB",
  LEAGUE = "LEAGUE",
  SPONSOR = "SPONSOR",
}


export type OrganizationResponse = {
  __typename: "OrganizationResponse",
  message: string,
  statusCode: number,
  success?: boolean | null,
};

export type QueryRecordInput = {
  createdBy?: string | null,
  description?: string | null,
  engagement: string,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
  query?: string | null,
  type?: string | null,
  validationStatus?: Status | null,
};

export type UserInput = {
  email: string,
  firstName: string,
  lastName: string,
  oktaUserId?: string | null,
  orgType: string,
  role: string,
};

export type UserResponse = {
  __typename: "UserResponse",
  message?: string | null,
  success?: boolean | null,
};

export type DataConnectionActionsInput = {
  action: DataConnectionActions,
  dataConnectionId: string,
  orgType: string,
  table_name?: string | null,
};

export enum DataConnectionActions {
  DEACTIVATE = "DEACTIVATE",
  DELETE = "DELETE",
  REACTIVATE = "REACTIVATE",
  SYNC = "SYNC",
}


export type LambdaResponse = {
  __typename: "LambdaResponse",
  body?: string | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type DeleteActivationChannelInput = {
  channelId: string,
  engagement: string,
};

export type ActivationChannelDeleteResponse = {
  __typename: "ActivationChannelDeleteResponse",
  message: string,
};

export type DeleteChartOrDashboardInput = {
  engagementId: string,
  entityId: string,
  entityType?: EntityType | null,
};

export enum EntityType {
  CHARTS = "CHARTS",
  DASHBOARDS = "DASHBOARDS",
}


export type DeleteResponse = {
  __typename: "DeleteResponse",
  message?: string | null,
  statusCode?: number | null,
};

export type collaborationDeleteInput = {
  action: Action,
  collaborationId: string,
  orgType: string,
};

export type DeleteModelInput = {
  engagement: string,
  modelId: string,
  parentId?: string | null,
};

export type DeleteModelResponse = {
  __typename: "DeleteModelResponse",
  message?: string | null,
  success: boolean,
};

export type DeleteBucketInput = {
  orgName: string,
};

export type ExportAudienceInput = {
  attributesMapping?: string | null,
  audienceFrom?: AudienceType | null,
  channelId: string,
  engagement: string,
  expireAt?: string | null,
  exportedBy: string,
  fileType?: FileType | null,
  folderPath?: string | null,
  orgType: string,
  queryId: string,
  queryName: string,
  targetChannel: AllowedChannel,
};

export type GenerateAiQueryInput = {
  analystId?: string | null,
  engagement: string,
  jobId?: string | null,
  queryType: QueryType,
  userQuery: string,
};

export type GenerateAiQueryType = {
  __typename: "GenerateAiQueryType",
  body?: string | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type ListUserInput = {
  orgType: string,
};

export type ListUsersResponse = {
  __typename: "ListUsersResponse",
  Users?:  Array<CognitoUser > | null,
};

export type CognitoUser = {
  __typename: "CognitoUser",
  Attributes?:  Array<UserAttribute > | null,
  Enabled?: boolean | null,
  Groups?: Array< string > | null,
  MFAOptions?:  Array<MFAOption > | null,
  UserCreateDate?: string | null,
  UserLastModifiedDate?: string | null,
  UserStatus?: string | null,
  Username?: string | null,
};

export type UserAttribute = {
  __typename: "UserAttribute",
  Name?: string | null,
  Value?: string | null,
};

export type MFAOption = {
  __typename: "MFAOption",
  AttributeName?: string | null,
  DeliveryMedium?: string | null,
};

export type ConnectionCreationResponse = {
  body?: NotifyDataConnectionCreationBodyInput | null,
  statusCode?: number | null,
};

export type NotifyDataConnectionCreationBodyInput = {
  connectionId?: string | null,
  message?: string | null,
};

export type NotifyDataConnectionCreationResponse = {
  __typename: "NotifyDataConnectionCreationResponse",
  body?: NotifyDataConnectionCreationBody | null,
  statusCode?: number | null,
};

export type NotifyDataConnectionCreationBody = {
  __typename: "NotifyDataConnectionCreationBody",
  connectionId?: string | null,
  message?: string | null,
};

export type ConnectionTestResponse = {
  connectionId?: string | null,
  message?: string | null,
  status?: string | null,
  statusCode?: number | null,
};

export type NotifyDataConnectionTestResponse = {
  __typename: "NotifyDataConnectionTestResponse",
  connectionId?: string | null,
  message?: string | null,
  status?: string | null,
  statusCode?: number | null,
};

export type AIQuerryGeneratedResponse = {
  aiComments?: string | null,
  generatedSql?: string | null,
  jobId: string,
  status: string,
  updatedAt: string,
};

export type NotifyJobCompleteType = {
  __typename: "NotifyJobCompleteType",
  body?: AiQueryGeneratedBody | null,
  jobId?: string | null,
  statusCode?: number | null,
};

export type AiQueryGeneratedBody = {
  __typename: "AiQueryGeneratedBody",
  aiComments?: string | null,
  generatedSql?: string | null,
  jobId?: string | null,
  status?: string | null,
  updatedAt?: string | null,
};

export type AudienceReminderEmailCheckResponse = {
  __typename: "AudienceReminderEmailCheckResponse",
  engagement: string,
};

export type QueryReminderEmailCheckResponse = {
  __typename: "QueryReminderEmailCheckResponse",
  engagement: string,
};

export type SendPartnerInviteRequest = {
  action: Action,
  collaborationId: string,
  lastModifiedBy?: string | null,
  orgType: string,
};

export type SubmitQueryInput = {
  engagement: string,
  lastModifiedBy: string,
  queryId: string,
};

export type AwsS3ConnectionInput = {
  awsAccountId: string,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType: ConnectionType,
  createdBy: string,
  glue?: boolean | null,
  kms?: boolean | null,
  orgType: string,
  s3?: boolean | null,
};

export enum ConnectionType {
  AWS_REDSHIFT = "AWS_REDSHIFT",
  AWS_S3 = "AWS_S3",
  AZURE_SYNAPSE = "AZURE_SYNAPSE",
  DATABRICKS = "DATABRICKS",
  FEDERATED_QUERY = "FEDERATED_QUERY",
  GCP_BIGQUERY = "GCP_BIGQUERY",
  GOOGLE_CLOUD_STORAGE = "GOOGLE_CLOUD_STORAGE",
  GRIDIRON_LF = "GRIDIRON_LF",
  MICROSOFT_ADLS = "MICROSOFT_ADLS",
  SFTP = "SFTP",
  SNOWFLAKE = "SNOWFLAKE",
}


export type TestConnectionResponse = {
  __typename: "TestConnectionResponse",
  connectionId?: string | null,
  message?: string | null,
  status?: string | null,
  statusCode?: number | null,
};

export type TestConnectionInput = {
  connectionType?: ConnectionType | null,
  redshiftInput?: redshiftTestInput | null,
  snowflakeInput?: snowflakeTestInput | null,
};

export type redshiftTestInput = {
  connectionName: string,
  databaseName: string,
  hostName: string,
  password: string,
  portNumber: number,
  schemaName: string,
  username: string,
};

export type snowflakeTestInput = {
  connectionName: string,
  databaseName: string,
  hostName: string,
  pem_private_key: string,
  portNumber: number,
  roleName: string,
  schemaName: string,
  sfUser: string,
  warehouseName: string,
};

export type DatabricksTestConnectionInput = {
  bearerToken: string,
  connectionId: string,
  connectionType: ConnectionType,
  endpoint: string,
  expirationTime: string,
  orgType: string,
  schemaName?: string | null,
  shareCredentialsVersion: number,
  shareName?: string | null,
};

export type TestGoogleActivationChannelInput = {
  channelType?: ChannelType | null,
  customerId: string,
  developerToken: string,
  loginCustomerId?: string | null,
  oauthClientId: string,
  oauthClientSecret: string,
  refreshToken: string,
};

export type TestGoogleActivationChannelResponse = {
  __typename: "TestGoogleActivationChannelResponse",
  customerInfo?: GoogleCustomerInfo | null,
  message: string,
  status: string,
};

export type GoogleCustomerInfo = {
  __typename: "GoogleCustomerInfo",
  currencyCode?: string | null,
  customerId?: string | null,
  descriptiveName?: string | null,
  timeZone?: string | null,
};

export type RedshiftTestConnectionInput = {
  connectionId: string,
  connectionType: ConnectionType,
  databaseName: string,
  hostName: string,
  orgType: string,
  password: string,
  portNumber: number,
  schemaName: string,
  username: string,
};

export type TestS3ActivationChannelInput = {
  awsRegion?: string | null,
  bucketName?: string | null,
  channelType?: ChannelType | null,
  iamRoleArn?: string | null,
};

export type TestS3ActivationChannelResponse = {
  __typename: "TestS3ActivationChannelResponse",
  message: string,
  status: string,
};

export type UpdateActivationChannelInput = {
  awsRegion?: string | null,
  bucketName?: string | null,
  channelId: string,
  channelSecrets?: string | null,
  channelType?: ChannelType | null,
  connectionStatus?: ConnectionStatus | null,
  description?: string | null,
  engagement: string,
  iamRoleArn?: string | null,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
};

export type ExecutionQueryInput = {
  CSVKey?: string | null,
  athenaExecutionId?: string | null,
  engagement: string,
  executionDuration?: number | null,
  executionEndTime?: string | null,
  executionFailReason?: string | null,
  executionStatus?: ExecutionStatus | null,
  lastModifiedBy?: string | null,
  metadata?: string | null,
  metadataKey?: string | null,
  queryId: string,
  syntheticResult?: SyntheticResultStatus | null,
};

export type UpdateModelInput = {
  engagement: string,
  images?: Array< string > | null,
  maxLookalikeNumber?: number | null,
  modelId: string,
  modelType: ModelType,
  seedAudienceSize?: number | null,
  status?: ModelStatus | null,
};

export type UpdateDatabricksFlagInput = {
  isDatabricksConnectionAllowed?: boolean | null,
  orgName: string,
};

export type UpdateDatabricksFlagResponse = {
  __typename: "UpdateDatabricksFlagResponse",
  message: string,
  statusCode: number,
  success?: boolean | null,
};

export type UpdateQueryInput = {
  approvalStatus?: ApprovalStatus | null,
  athenaExecutionId?: string | null,
  description?: string | null,
  engagement: string,
  lastModifiedBy?: string | null,
  name?: string | null,
  orgType?: string | null,
  query?: string | null,
  queryId: string,
  rejectReason?: string | null,
  syntheticResult?: SyntheticResultStatus | null,
  type?: QueryType | null,
  validationLogs?: string | null,
  validationStatus?: Status | null,
};

export type UpdateInactiveEngagementInput = {
  dataConnectionId: string,
  orgType: string,
};

export type UpdateQueryStatusResponse = {
  __typename: "UpdateQueryStatusResponse",
  engagement: string,
};

export type UpdateUserInput = {
  SFTPEnabled?: boolean | null,
  action: UserActions,
  cognitoUserSub: string,
  firstName?: string | null,
  isNFLAdmin?: boolean | null,
  lastName?: string | null,
  orgType?: string | null,
  role?: string | null,
};

export enum UserActions {
  ACTIVATE_USER = "ACTIVATE_USER",
  DEACTIVATE_USER = "DEACTIVATE_USER",
  DELETE_USER = "DELETE_USER",
  UPDATE_USER = "UPDATE_USER",
}


export type UserActionsInput = {
  action: UserActions,
  cognitoUserSub: string,
};

export type UserActionsResponse = {
  __typename: "UserActionsResponse",
  message?: string | null,
  success?: boolean | null,
};

export type AdlsConnectionInput = {
  connectionId?: string | null,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType?: ConnectionType | null,
  databaseName: string,
  engagement: string,
  hostName: string,
  lastModifiedBy: string,
  orgType: string,
  password: string,
  portNumber: number,
  username: string,
};

export type DataConnection = {
  __typename: "DataConnection",
  accessKeyId?: string | null,
  awsRegion?: string | null,
  bigQueryEndpoint?: string | null,
  bucketName?: string | null,
  catalogName?: string | null,
  connectionId: string,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType?: ConnectionType | null,
  createdAt?: string | null,
  createdBy?: string | null,
  databaseName?: string | null,
  description?: string | null,
  engagement?: string | null,
  gcsJsonCredentials?: string | null,
  hostName?: string | null,
  jsonCredentials?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  metadata?:  Array<Metadata | null > | null,
  orgType: string,
  password?: string | null,
  pem_private_key?: string | null,
  portNumber?: number | null,
  projectId?: string | null,
  region?: string | null,
  roleArn?: string | null,
  roleName?: string | null,
  schemaName?: string | null,
  secretAccessKey?: string | null,
  sfUser?: string | null,
  sourceAccountId?: string | null,
  targetAccountId?: string | null,
  username?: string | null,
  warehouseName?: string | null,
};

export type Metadata = {
  __typename: "Metadata",
  columns?:  Array<DataConnectionMetadataColumns > | null,
  dataConnectionId?: string | null,
  database_name?: string | null,
  datasource_name?: string | null,
  row_count?: string | null,
  sync_status?: SyncStatus | null,
  table_description?: string | null,
  table_name?: string | null,
};

export type DataConnectionMetadataColumns = {
  __typename: "DataConnectionMetadataColumns",
  comment?: string | null,
  description?: string | null,
  identifier?: IdentifierType | null,
  name?: string | null,
  parameters?: string | null,
  type?: string | null,
};

export enum IdentifierType {
  EMAIL = "EMAIL",
  NONE = "NONE",
  UNIQUE = "UNIQUE",
}


export enum SyncStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
}


export type BigQueryConnectionInput = {
  bigQueryEndpoint?: string | null,
  connectionId?: string | null,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType?: ConnectionType | null,
  engagement: string,
  jsonCredentials: string,
  lastModifiedBy: string,
  orgType: string,
  projectId: string,
};

export type DatabricksConnectionInput = {
  bearerToken: string,
  connectionId?: string | null,
  connectionName?: string | null,
  connectionStatus?: ConnectionStatus | null,
  connectionType: ConnectionType,
  createdBy?: string | null,
  endpoint: string,
  expirationTime: string,
  orgType: string,
  schemaName?: string | null,
  shareCredentialsVersion: number,
  shareName: string,
};

export type FederatedQueryConnectionInput = {
  accessKeyId: string,
  awsRegion: string,
  catalogName: string,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType: ConnectionType,
  createdBy: string,
  orgType: string,
  roleArn: string,
  secretAccessKey: string,
  sourceAccountId: string,
  targetAccountId: string,
};

export type GcsConnectionInput = {
  connectionId?: string | null,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType?: ConnectionType | null,
  engagement: string,
  gcsJsonCredentials: string,
  lastModifiedBy: string,
  orgType: string,
};

export type RedshiftConnectionInput = {
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType: ConnectionType,
  createdBy: string,
  databaseName: string,
  hostName: string,
  orgType: string,
  password: string,
  portNumber: number,
  schemaName: string,
  username: string,
};

export type SFTPConnectionInput = {
  connectionId?: string | null,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType: ConnectionType,
  createdBy: string,
  lastModifiedBy?: string | null,
  orgType: string,
  s3Bucket: string,
  s3FolderPath: string,
};

export type SnowflakeConnectionInput = {
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType: ConnectionType,
  createdBy: string,
  databaseName: string,
  hostName: string,
  orgType: string,
  pem_private_key: string,
  portNumber: number,
  roleName: string,
  schemaName: string,
  sfUser: string,
  warehouseName: string,
};

export type SynapseConnectionInput = {
  connectionId?: string | null,
  connectionName: string,
  connectionStatus?: ConnectionStatus | null,
  connectionType?: ConnectionType | null,
  databaseName: string,
  engagement: string,
  hostName: string,
  lastModifiedBy: string,
  orgType: string,
  password: string,
  portNumber: number,
  username: string,
};

export type UpdateDataConnectionInput = {
  accessKeyId?: string | null,
  awsRegion?: string | null,
  bigQueryEndpoint?: string | null,
  bucketName?: string | null,
  catalogName?: string | null,
  connectionId: string,
  connectionName?: string | null,
  connectionStatus?: ConnectionStatus | null,
  connectionType?: ConnectionType | null,
  databaseName?: string | null,
  description?: string | null,
  engagement?: string | null,
  gcsJsonCredentials?: string | null,
  hostName?: string | null,
  jsonCredentials?: string | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  orgType: string,
  password?: string | null,
  pem_private_key?: string | null,
  portNumber?: number | null,
  projectId?: string | null,
  region?: string | null,
  roleArn?: string | null,
  roleName?: string | null,
  schemaName?: string | null,
  secretAccessKey?: string | null,
  sfUser?: string | null,
  sourceAccountId?: string | null,
  targetAccountId?: string | null,
  username?: string | null,
  warehouseName?: string | null,
};

export type UpdateDataConnectionMetaDataInput = {
  connectionId: string,
  lastModifiedBy?: string | null,
  metadata: string,
  orgType: string,
  table_name?: string | null,
};

export type AggregateResultRequest = {
  action?: ResultAction | null,
  athenaExecutionId: string,
  engagement: string,
  queryId: string,
};

export enum ResultAction {
  GET_AGGREGATE_RESULT = "GET_AGGREGATE_RESULT",
  GET_SYNTHETIC_RESULT = "GET_SYNTHETIC_RESULT",
}


export type AggregateResultResponse = {
  __typename: "AggregateResultResponse",
  headers?: Array< string > | null,
  rows?: string | null,
  total?: number | null,
};

export type CollaborationDetailsRequest = {
  action: Action,
  collaborationId: string,
  loggedInUserOrg: OrgType,
  orgType: string,
};

export type CollaborationListRequest = {
  action: Action,
  loggedInUserOrg: OrgType,
  orgType: string,
};

export type CollaborationListResponse = {
  __typename: "CollaborationListResponse",
  collaborationList?:  Array<Collaboration > | null,
  message?: string | null,
  statusCode?: number | null,
  success: boolean,
};

export type DashboardNameInfo = {
  __typename: "DashboardNameInfo",
  dashboardId: string,
  name?: string | null,
};

export type DataConnectionList = {
  __typename: "DataConnectionList",
  dataConnectionList?:  Array<DataConnection > | null,
  metadataList?: string | null,
};

export type Engagements = {
  __typename: "Engagements",
  engagement: string,
  metadata?:  Array<EngagementsMetadata > | null,
  status?: EngagementStatus | null,
};

export type EngagementsMetadata = {
  __typename: "EngagementsMetadata",
  columns?:  Array<MetadataColumns > | null,
  dataConnectionId?: string | null,
  database_name?: string | null,
  datasource_name?: string | null,
  row_count?: string | null,
  sync_status?: SyncStatus | null,
  table_name?: string | null,
};

export type MetadataColumns = {
  __typename: "MetadataColumns",
  comment?: string | null,
  description?: string | null,
  identifier?: IdentifierType | null,
  name?: string | null,
  parameters?: string | null,
  type?: string | null,
};

export enum EngagementStatus {
  ACTIVE = "ACTIVE",
  ON_HOLD = "ON_HOLD",
}


export type Entitlements = {
  __typename: "Entitlements",
  entitlements?: Array< string > | null,
  role?: string | null,
};

export type HealthResponse = {
  __typename: "HealthResponse",
  status: string,
};

export type Organization = {
  __typename: "Organization",
  isDatabricksConnectionAllowed?: boolean | null,
  orgName: string,
  orgType: OrgType,
  s3Bucket?: string | null,
};

export type PartnerEmailInput = {
  action: string,
  email: string,
};

export type PartnerEmailResponse = {
  __typename: "PartnerEmailResponse",
  data?: PartnerEmailsData | null,
  message?: string | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type PartnerEmailsData = {
  __typename: "PartnerEmailsData",
  admins?: Array< string > | null,
  email: string,
  name: string,
  orgType: string,
};

export type PreSignedUrl = {
  bucketSuffix: string,
  contentType: string,
  s3keyName: string,
};

export type PreSignedUrlResponse = {
  __typename: "PreSignedUrlResponse",
  deleteUrl?: string | null,
  error?: string | null,
  putUrl?: string | null,
  statusCode?: number | null,
};

export type QueryRecordRequest = {
  engagement?: string | null,
  lastModifiedBy?: string | null,
  query?: string | null,
  queryId?: string | null,
  queryType?: QueryType | null,
  validationStatus?: Status | null,
};

export type ValidationMessageResponse = {
  __typename: "ValidationMessageResponse",
  message?: string | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type AcceptOrDeclineCollaborationMutationVariables = {
  collaborationRequest: collaborationUpdateInput,
};

export type AcceptOrDeclineCollaborationMutation = {
  AcceptOrDeclineCollaboration:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type ApproveExportAudienceMutationVariables = {
  updateAudienceExportRequest: ApproveExportAudienceInput,
};

export type ApproveExportAudienceMutation = {
  ApproveExportAudience:  {
    __typename: "ExportAudience",
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    attributesMapping?: string | null,
    audienceFrom?: AudienceType | null,
    channelId?: string | null,
    engagement: string,
    expireAt?: string | null,
    exportId: string,
    exportStatus?: ExportStatus | null,
    exportedAt?: string | null,
    exportedBy?: string | null,
    fileType?: FileType | null,
    folderPath?: string | null,
    orgType?: string | null,
    queryId?: string | null,
    queryName?: string | null,
    rejectReason?: string | null,
    targetChannel?: AllowedChannel | null,
  },
};

export type ApproveQueryRecordMutationVariables = {
  updateQueryRequest: ApproveQueryInput,
};

export type ApproveQueryRecordMutation = {
  ApproveQueryRecord:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  },
};

export type CheckQueryStatusMutationVariables = {
};

export type CheckQueryStatusMutation = {
  CheckQueryStatus:  {
    __typename: "QueryStatusResponse",
    message?: string | null,
  },
};

export type CleanupSyntheticDataMutationVariables = {
  syntheticDataInput: SyntheticDataGenerationInput,
};

export type CleanupSyntheticDataMutation = {
  CleanupSyntheticData:  {
    __typename: "SyntheticDataGenerationResponse",
    message: string,
    statusCode: number,
    success: boolean,
  },
};

export type CleanupSyntheticResultMutationVariables = {
  syntheticDataInput: SyntheticResultGenerationInput,
};

export type CleanupSyntheticResultMutation = {
  CleanupSyntheticResult:  {
    __typename: "SyntheticDataGenerationResponse",
    message: string,
    statusCode: number,
    success: boolean,
  },
};

export type CreateActivationChannelMutationVariables = {
  activationChannelInput: ActivationChannelInput,
};

export type CreateActivationChannelMutation = {
  CreateActivationChannel:  {
    __typename: "ActivationChannel",
    awsRegion?: string | null,
    bucketName?: string | null,
    channelId: string,
    channelType?: ChannelType | null,
    connectionStatus?: ConnectionStatus | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    iamRoleArn?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgType?: string | null,
  },
};

export type CreateChartsMutationVariables = {
  input: SaveChartInput,
};

export type CreateChartsMutation = {
  CreateCharts?:  {
    __typename: "ChartMetadata",
    athenaExecutionId?: string | null,
    chartId: string,
    chartType: ChartType,
    chartsImageUrl?: string | null,
    config?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardIds?: Array< string > | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgType?: string | null,
    queryId?: string | null,
  } | null,
};

export type CreateCollaborationMutationVariables = {
  collaborationRequest: collaborationCreateInput,
};

export type CreateCollaborationMutation = {
  CreateCollaboration:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type CreateDashboardMutationVariables = {
  input: SaveDashboardInput,
};

export type CreateDashboardMutation = {
  CreateDashboard?:  {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    layout?: string | null,
    name?: string | null,
    orgType?: string | null,
  } | null,
};

export type CreateEngagementMutationVariables = {
  createEngagementInput: CreateEngagementInput,
};

export type CreateEngagementMutation = {
  CreateEngagement:  {
    __typename: "CreateEngagementResponse",
    message: string,
    statusCode: number,
    success?: boolean | null,
  },
};

export type CreateModelMutationVariables = {
  input: CreateModelInput,
};

export type CreateModelMutation = {
  CreateModel:  {
    __typename: "Response",
    data?:  {
      __typename: "Model",
      athenaExecutionId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      engagement: string,
      images?: Array< string > | null,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      lookalikeNumber?: number | null,
      maxLookalikeNumber?: number | null,
      metadata?: string | null,
      modelId: string,
      modelType?: ModelType | null,
      name?: string | null,
      orgType?: string | null,
      parentId?: string | null,
      queryId: string,
      queryName?: string | null,
      seedAudienceSize?: number | null,
      status?: ModelStatus | null,
    } | null,
    statusCode?: number | null,
    statusMessage?: string | null,
    success: boolean,
  },
};

export type CreateNewEngagementMutationVariables = {
  createEngagementInput: CreateNewEngagementInput,
};

export type CreateNewEngagementMutation = {
  CreateNewEngagement:  {
    __typename: "CreateEngagementResponse",
    message: string,
    statusCode: number,
    success?: boolean | null,
  },
};

export type CreateOrganizationMutationVariables = {
  organizationInput: OrganizationInput,
};

export type CreateOrganizationMutation = {
  CreateOrganization:  {
    __typename: "OrganizationResponse",
    message: string,
    statusCode: number,
    success?: boolean | null,
  },
};

export type CreateQueryRecordMutationVariables = {
  queryRecordInput: QueryRecordInput,
};

export type CreateQueryRecordMutation = {
  CreateQueryRecord:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  },
};

export type CreateUserMutationVariables = {
  userRequest: UserInput,
};

export type CreateUserMutation = {
  CreateUser:  {
    __typename: "UserResponse",
    message?: string | null,
    success?: boolean | null,
  },
};

export type DataConnectionActionsMutationVariables = {
  dataConnectionActionsInput: DataConnectionActionsInput,
};

export type DataConnectionActionsMutation = {
  DataConnectionActions:  {
    __typename: "LambdaResponse",
    body?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type DeleteActivationChannelMutationVariables = {
  activationChannelInput: DeleteActivationChannelInput,
};

export type DeleteActivationChannelMutation = {
  DeleteActivationChannel:  {
    __typename: "ActivationChannelDeleteResponse",
    message: string,
  },
};

export type DeleteChartsOrDashboardsMutationVariables = {
  input: DeleteChartOrDashboardInput,
};

export type DeleteChartsOrDashboardsMutation = {
  DeleteChartsOrDashboards?:  {
    __typename: "DeleteResponse",
    message?: string | null,
    statusCode?: number | null,
  } | null,
};

export type DeleteCollaborationMutationVariables = {
  collaborationRequest: collaborationDeleteInput,
};

export type DeleteCollaborationMutation = {
  DeleteCollaboration:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type DeleteModelMutationVariables = {
  input: DeleteModelInput,
};

export type DeleteModelMutation = {
  DeleteModel:  {
    __typename: "DeleteModelResponse",
    message?: string | null,
    success: boolean,
  },
};

export type DeleteOrganizationBucketMutationVariables = {
  deleteBucketInput: DeleteBucketInput,
};

export type DeleteOrganizationBucketMutation = {
  DeleteOrganizationBucket?:  {
    __typename: "OrganizationResponse",
    message: string,
    statusCode: number,
    success?: boolean | null,
  } | null,
};

export type EditDashboardMutationVariables = {
  input: SaveDashboardInput,
};

export type EditDashboardMutation = {
  EditDashboard?:  {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    layout?: string | null,
    name?: string | null,
    orgType?: string | null,
  } | null,
};

export type ExportAudienceMutationVariables = {
  exportAudienceRequest: ExportAudienceInput,
};

export type ExportAudienceMutation = {
  ExportAudience:  {
    __typename: "ExportAudience",
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    attributesMapping?: string | null,
    audienceFrom?: AudienceType | null,
    channelId?: string | null,
    engagement: string,
    expireAt?: string | null,
    exportId: string,
    exportStatus?: ExportStatus | null,
    exportedAt?: string | null,
    exportedBy?: string | null,
    fileType?: FileType | null,
    folderPath?: string | null,
    orgType?: string | null,
    queryId?: string | null,
    queryName?: string | null,
    rejectReason?: string | null,
    targetChannel?: AllowedChannel | null,
  },
};

export type GenerateAiQueryMutationVariables = {
  generateAiQueryInput: GenerateAiQueryInput,
};

export type GenerateAiQueryMutation = {
  GenerateAiQuery:  {
    __typename: "GenerateAiQueryType",
    body?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type GenerateSyntheticDataMutationVariables = {
  syntheticDataInput: SyntheticDataGenerationInput,
};

export type GenerateSyntheticDataMutation = {
  GenerateSyntheticData:  {
    __typename: "SyntheticDataGenerationResponse",
    message: string,
    statusCode: number,
    success: boolean,
  },
};

export type GenerateSyntheticResultMutationVariables = {
  syntheticDataInput: SyntheticResultGenerationInput,
};

export type GenerateSyntheticResultMutation = {
  GenerateSyntheticResult:  {
    __typename: "SyntheticDataGenerationResponse",
    message: string,
    statusCode: number,
    success: boolean,
  },
};

export type ListUsersMutationVariables = {
  userRequest: ListUserInput,
};

export type ListUsersMutation = {
  ListUsers:  {
    __typename: "ListUsersResponse",
    Users?:  Array< {
      __typename: "CognitoUser",
      Attributes?:  Array< {
        __typename: "UserAttribute",
        Name?: string | null,
        Value?: string | null,
      } > | null,
      Enabled?: boolean | null,
      Groups?: Array< string > | null,
      MFAOptions?:  Array< {
        __typename: "MFAOption",
        AttributeName?: string | null,
        DeliveryMedium?: string | null,
      } > | null,
      UserCreateDate?: string | null,
      UserLastModifiedDate?: string | null,
      UserStatus?: string | null,
      Username?: string | null,
    } > | null,
  },
};

export type NotifyDataConnectionCreationMutationVariables = {
  connectionCreationResponse: ConnectionCreationResponse,
};

export type NotifyDataConnectionCreationMutation = {
  NotifyDataConnectionCreation:  {
    __typename: "NotifyDataConnectionCreationResponse",
    body?:  {
      __typename: "NotifyDataConnectionCreationBody",
      connectionId?: string | null,
      message?: string | null,
    } | null,
    statusCode?: number | null,
  },
};

export type NotifyDataConnectionTestMutationVariables = {
  connectionTestResponse: ConnectionTestResponse,
};

export type NotifyDataConnectionTestMutation = {
  NotifyDataConnectionTest:  {
    __typename: "NotifyDataConnectionTestResponse",
    connectionId?: string | null,
    message?: string | null,
    status?: string | null,
    statusCode?: number | null,
  },
};

export type NotifyJobCompleteMutationVariables = {
  AIQuerryGeneratedResponse: AIQuerryGeneratedResponse,
};

export type NotifyJobCompleteMutation = {
  NotifyJobComplete:  {
    __typename: "NotifyJobCompleteType",
    body?:  {
      __typename: "AiQueryGeneratedBody",
      aiComments?: string | null,
      generatedSql?: string | null,
      jobId?: string | null,
      status?: string | null,
      updatedAt?: string | null,
    } | null,
    jobId?: string | null,
    statusCode?: number | null,
  },
};

export type ReminderEmailForExportAudienceMutationVariables = {
};

export type ReminderEmailForExportAudienceMutation = {
  ReminderEmailForExportAudience:  Array< {
    __typename: "AudienceReminderEmailCheckResponse",
    engagement: string,
  } | null >,
};

export type ReminderEmailForQueryRecordMutationVariables = {
};

export type ReminderEmailForQueryRecordMutation = {
  ReminderEmailForQueryRecord:  Array< {
    __typename: "QueryReminderEmailCheckResponse",
    engagement: string,
  } | null >,
};

export type SendCollaborationInviteMutationVariables = {
  collaborationRequest: SendPartnerInviteRequest,
};

export type SendCollaborationInviteMutation = {
  SendCollaborationInvite:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type SubmitQueryRecordMutationVariables = {
  updateQueryRequest: SubmitQueryInput,
};

export type SubmitQueryRecordMutation = {
  SubmitQueryRecord:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  },
};

export type TestAwsS3DataConnectionMutationVariables = {
  testDataConnectionInput: AwsS3ConnectionInput,
};

export type TestAwsS3DataConnectionMutation = {
  TestAwsS3DataConnection:  {
    __typename: "TestConnectionResponse",
    connectionId?: string | null,
    message?: string | null,
    status?: string | null,
    statusCode?: number | null,
  },
};

export type TestDataConnectionMutationVariables = {
  testDataConnectionInput: TestConnectionInput,
};

export type TestDataConnectionMutation = {
  TestDataConnection:  {
    __typename: "TestConnectionResponse",
    connectionId?: string | null,
    message?: string | null,
    status?: string | null,
    statusCode?: number | null,
  },
};

export type TestDatabricksDataConnectionMutationVariables = {
  testDataConnectionInput: DatabricksTestConnectionInput,
};

export type TestDatabricksDataConnectionMutation = {
  TestDatabricksDataConnection?:  {
    __typename: "TestConnectionResponse",
    connectionId?: string | null,
    message?: string | null,
    status?: string | null,
    statusCode?: number | null,
  } | null,
};

export type TestGoogleActivationChannelMutationVariables = {
  testRequest?: TestGoogleActivationChannelInput | null,
};

export type TestGoogleActivationChannelMutation = {
  TestGoogleActivationChannel:  {
    __typename: "TestGoogleActivationChannelResponse",
    customerInfo?:  {
      __typename: "GoogleCustomerInfo",
      currencyCode?: string | null,
      customerId?: string | null,
      descriptiveName?: string | null,
      timeZone?: string | null,
    } | null,
    message: string,
    status: string,
  },
};

export type TestRedshiftDataConnectionMutationVariables = {
  testDataConnectionInput: RedshiftTestConnectionInput,
};

export type TestRedshiftDataConnectionMutation = {
  TestRedshiftDataConnection:  {
    __typename: "TestConnectionResponse",
    connectionId?: string | null,
    message?: string | null,
    status?: string | null,
    statusCode?: number | null,
  },
};

export type TestS3ActivationChannelMutationVariables = {
  testRequest?: TestS3ActivationChannelInput | null,
};

export type TestS3ActivationChannelMutation = {
  TestS3ActivationChannel:  {
    __typename: "TestS3ActivationChannelResponse",
    message: string,
    status: string,
  },
};

export type UpdateActivationChannelMutationVariables = {
  activationChannelInput: UpdateActivationChannelInput,
};

export type UpdateActivationChannelMutation = {
  UpdateActivationChannel:  {
    __typename: "ActivationChannel",
    awsRegion?: string | null,
    bucketName?: string | null,
    channelId: string,
    channelType?: ChannelType | null,
    connectionStatus?: ConnectionStatus | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    iamRoleArn?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgType?: string | null,
  },
};

export type UpdateCollaborationMutationVariables = {
  collaborationRequest: collaborationUpdateInput,
};

export type UpdateCollaborationMutation = {
  UpdateCollaboration:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type UpdateCollaborationDatasetMutationVariables = {
  collaborationRequest: collaborationUpdateInput,
};

export type UpdateCollaborationDatasetMutation = {
  UpdateCollaborationDataset:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type UpdateExecutionQueryRecordMutationVariables = {
  updateQueryRequest: ExecutionQueryInput,
};

export type UpdateExecutionQueryRecordMutation = {
  UpdateExecutionQueryRecord:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  },
};

export type UpdateModelMutationVariables = {
  input?: UpdateModelInput | null,
};

export type UpdateModelMutation = {
  UpdateModel:  {
    __typename: "Response",
    data?:  {
      __typename: "Model",
      athenaExecutionId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      engagement: string,
      images?: Array< string > | null,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      lookalikeNumber?: number | null,
      maxLookalikeNumber?: number | null,
      metadata?: string | null,
      modelId: string,
      modelType?: ModelType | null,
      name?: string | null,
      orgType?: string | null,
      parentId?: string | null,
      queryId: string,
      queryName?: string | null,
      seedAudienceSize?: number | null,
      status?: ModelStatus | null,
    } | null,
    statusCode?: number | null,
    statusMessage?: string | null,
    success: boolean,
  },
};

export type UpdateOrganizationDatabricksFlagMutationVariables = {
  updateDatabricksFlagInput: UpdateDatabricksFlagInput,
};

export type UpdateOrganizationDatabricksFlagMutation = {
  UpdateOrganizationDatabricksFlag?:  {
    __typename: "UpdateDatabricksFlagResponse",
    message: string,
    statusCode: number,
    success?: boolean | null,
  } | null,
};

export type UpdateQueryRecordMutationVariables = {
  updateQueryRequest: UpdateQueryInput,
};

export type UpdateQueryRecordMutation = {
  UpdateQueryRecord:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  },
};

export type UpdateQueryRecordForInactiveCollaborationMutationVariables = {
  engagement?: string | null,
};

export type UpdateQueryRecordForInactiveCollaborationMutation = {
  UpdateQueryRecordForInactiveCollaboration:  Array< {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  } | null >,
};

export type UpdateQueryRecordForInactiveEngagementMutationVariables = {
  updateRequest: UpdateInactiveEngagementInput,
};

export type UpdateQueryRecordForInactiveEngagementMutation = {
  UpdateQueryRecordForInactiveEngagement:  Array< {
    __typename: "UpdateQueryStatusResponse",
    engagement: string,
  } | null >,
};

export type UpdateUserMutationVariables = {
  userRequest: UpdateUserInput,
};

export type UpdateUserMutation = {
  UpdateUser:  {
    __typename: "UserResponse",
    message?: string | null,
    success?: boolean | null,
  },
};

export type UserActionsMutationVariables = {
  userRequest: UserActionsInput,
};

export type UserActionsMutation = {
  UserActions:  {
    __typename: "UserActionsResponse",
    message?: string | null,
    success?: boolean | null,
  },
};

export type CreateAdlsDataConnectionMutationVariables = {
  dataConnectionInput: AdlsConnectionInput,
};

export type CreateAdlsDataConnectionMutation = {
  createAdlsDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateBigQueryDataConnectionMutationVariables = {
  dataConnectionInput: BigQueryConnectionInput,
};

export type CreateBigQueryDataConnectionMutation = {
  createBigQueryDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateDatabricksDataConnectionMutationVariables = {
  dataConnectionInput: DatabricksConnectionInput,
};

export type CreateDatabricksDataConnectionMutation = {
  createDatabricksDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateFederatedQueryDataConnectionMutationVariables = {
  dataConnectionInput: FederatedQueryConnectionInput,
};

export type CreateFederatedQueryDataConnectionMutation = {
  createFederatedQueryDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateGcsDataConnectionMutationVariables = {
  dataConnectionInput: GcsConnectionInput,
};

export type CreateGcsDataConnectionMutation = {
  createGcsDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateRedshiftDataConnectionMutationVariables = {
  dataConnectionInput: RedshiftConnectionInput,
};

export type CreateRedshiftDataConnectionMutation = {
  createRedshiftDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateS3DataConnectionMutationVariables = {
  dataConnectionInput: AwsS3ConnectionInput,
};

export type CreateS3DataConnectionMutation = {
  createS3DataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateSFTPDataConnectionMutationVariables = {
  dataConnectionInput: SFTPConnectionInput,
};

export type CreateSFTPDataConnectionMutation = {
  createSFTPDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateSnowflakeDataConnectionMutationVariables = {
  dataConnectionInput: SnowflakeConnectionInput,
};

export type CreateSnowflakeDataConnectionMutation = {
  createSnowflakeDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type CreateSynapseDataConnectionMutationVariables = {
  dataConnectionInput: SynapseConnectionInput,
};

export type CreateSynapseDataConnectionMutation = {
  createSynapseDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type UpdateDataConnectionMutationVariables = {
  dataConnectionInput: UpdateDataConnectionInput,
};

export type UpdateDataConnectionMutation = {
  updateDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type UpdateDataConnectionMetaDataMutationVariables = {
  dataConnectionInput: UpdateDataConnectionMetaDataInput,
};

export type UpdateDataConnectionMetaDataMutation = {
  updateDataConnectionMetaData:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type UpdateSFTPDataConnectionMutationVariables = {
  dataConnectionInput: SFTPConnectionInput,
};

export type UpdateSFTPDataConnectionMutation = {
  updateSFTPDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type GetActivationChannelsQueryVariables = {
  engagementId: string,
};

export type GetActivationChannelsQuery = {
  GetActivationChannels?:  Array< {
    __typename: "ActivationChannel",
    awsRegion?: string | null,
    bucketName?: string | null,
    channelId: string,
    channelType?: ChannelType | null,
    connectionStatus?: ConnectionStatus | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    iamRoleArn?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgType?: string | null,
  } | null > | null,
};

export type GetAggregateResultQueryVariables = {
  resultRequest?: AggregateResultRequest | null,
};

export type GetAggregateResultQuery = {
  GetAggregateResult?:  {
    __typename: "AggregateResultResponse",
    headers?: Array< string > | null,
    rows?: string | null,
    total?: number | null,
  } | null,
};

export type GetChartQueryVariables = {
  chartId: string,
  engagementId: string,
};

export type GetChartQuery = {
  GetChart?:  {
    __typename: "ChartMetadata",
    athenaExecutionId?: string | null,
    chartId: string,
    chartType: ChartType,
    chartsImageUrl?: string | null,
    config?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardIds?: Array< string > | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgType?: string | null,
    queryId?: string | null,
  } | null,
};

export type GetChartsQueryVariables = {
  engagementId: string,
};

export type GetChartsQuery = {
  GetCharts?:  Array< {
    __typename: "ChartMetadata",
    athenaExecutionId?: string | null,
    chartId: string,
    chartType: ChartType,
    chartsImageUrl?: string | null,
    config?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardIds?: Array< string > | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    name?: string | null,
    orgType?: string | null,
    queryId?: string | null,
  } | null > | null,
};

export type GetCollaborationQueryVariables = {
  collaborationRequest: CollaborationDetailsRequest,
};

export type GetCollaborationQuery = {
  GetCollaboration:  {
    __typename: "CollaborationResponse",
    data?:  {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type GetCollaborationListQueryVariables = {
  collaborationRequest: CollaborationListRequest,
};

export type GetCollaborationListQuery = {
  GetCollaborationList:  {
    __typename: "CollaborationListResponse",
    collaborationList?:  Array< {
      __typename: "Collaboration",
      collaborationId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      description: string,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      name: string,
      objective: string,
      orgType: string,
      ownerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerDatasets?:  Array< {
        __typename: "Dataset",
        dataConnectionId: string,
        dataConnectionName: string,
        schemaName: string,
        tableName: string,
      } > | null,
      partnerEmail?: Array< string > | null,
      partnerInviteMessage?: string | null,
      partnerOrgType?: string | null,
      status: CollaborationStatus,
    } > | null,
    message?: string | null,
    statusCode?: number | null,
    success: boolean,
  },
};

export type GetDashboardQueryVariables = {
  dashboardId: string,
  engagementId: string,
};

export type GetDashboardQuery = {
  GetDashboard?:  {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    layout?: string | null,
    name?: string | null,
    orgType?: string | null,
  } | null,
};

export type GetDashboardNamesQueryVariables = {
  dashboardIds: Array< string >,
  engagementId: string,
};

export type GetDashboardNamesQuery = {
  GetDashboardNames?:  Array< {
    __typename: "DashboardNameInfo",
    dashboardId: string,
    name?: string | null,
  } | null > | null,
};

export type GetDashboardsQueryVariables = {
  engagementId: string,
};

export type GetDashboardsQuery = {
  GetDashboards?:  Array< {
    __typename: "DashboardMetadata",
    chartIds?: Array< string > | null,
    createdAt?: string | null,
    createdBy?: string | null,
    dashboardId: string,
    dashboardImageUrl?: string | null,
    description?: string | null,
    engagement: string,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    layout?: string | null,
    name?: string | null,
    orgType?: string | null,
  } | null > | null,
};

export type GetDataConnectionQueryVariables = {
  connectionId: string,
  orgType: string,
};

export type GetDataConnectionQuery = {
  GetDataConnection:  {
    __typename: "DataConnection",
    accessKeyId?: string | null,
    awsRegion?: string | null,
    bigQueryEndpoint?: string | null,
    bucketName?: string | null,
    catalogName?: string | null,
    connectionId: string,
    connectionName: string,
    connectionStatus?: ConnectionStatus | null,
    connectionType?: ConnectionType | null,
    createdAt?: string | null,
    createdBy?: string | null,
    databaseName?: string | null,
    description?: string | null,
    engagement?: string | null,
    gcsJsonCredentials?: string | null,
    hostName?: string | null,
    jsonCredentials?: string | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?:  Array< {
      __typename: "Metadata",
      columns?:  Array< {
        __typename: "DataConnectionMetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_description?: string | null,
      table_name?: string | null,
    } | null > | null,
    orgType: string,
    password?: string | null,
    pem_private_key?: string | null,
    portNumber?: number | null,
    projectId?: string | null,
    region?: string | null,
    roleArn?: string | null,
    roleName?: string | null,
    schemaName?: string | null,
    secretAccessKey?: string | null,
    sfUser?: string | null,
    sourceAccountId?: string | null,
    targetAccountId?: string | null,
    username?: string | null,
    warehouseName?: string | null,
  },
};

export type GetDataConnectionListQueryVariables = {
  orgType: string,
};

export type GetDataConnectionListQuery = {
  GetDataConnectionList:  {
    __typename: "DataConnectionList",
    dataConnectionList?:  Array< {
      __typename: "DataConnection",
      accessKeyId?: string | null,
      awsRegion?: string | null,
      bigQueryEndpoint?: string | null,
      bucketName?: string | null,
      catalogName?: string | null,
      connectionId: string,
      connectionName: string,
      connectionStatus?: ConnectionStatus | null,
      connectionType?: ConnectionType | null,
      createdAt?: string | null,
      createdBy?: string | null,
      databaseName?: string | null,
      description?: string | null,
      engagement?: string | null,
      gcsJsonCredentials?: string | null,
      hostName?: string | null,
      jsonCredentials?: string | null,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      metadata?:  Array< {
        __typename: "Metadata",
        columns?:  Array< {
          __typename: "DataConnectionMetadataColumns",
          comment?: string | null,
          description?: string | null,
          identifier?: IdentifierType | null,
          name?: string | null,
          parameters?: string | null,
          type?: string | null,
        } > | null,
        dataConnectionId?: string | null,
        database_name?: string | null,
        datasource_name?: string | null,
        row_count?: string | null,
        sync_status?: SyncStatus | null,
        table_description?: string | null,
        table_name?: string | null,
      } | null > | null,
      orgType: string,
      password?: string | null,
      pem_private_key?: string | null,
      portNumber?: number | null,
      projectId?: string | null,
      region?: string | null,
      roleArn?: string | null,
      roleName?: string | null,
      schemaName?: string | null,
      secretAccessKey?: string | null,
      sfUser?: string | null,
      sourceAccountId?: string | null,
      targetAccountId?: string | null,
      username?: string | null,
      warehouseName?: string | null,
    } > | null,
    metadataList?: string | null,
  },
};

export type GetEngagementsQueryVariables = {
  organizationType: string,
};

export type GetEngagementsQuery = {
  GetEngagements?:  Array< {
    __typename: "Engagements",
    engagement: string,
    metadata?:  Array< {
      __typename: "EngagementsMetadata",
      columns?:  Array< {
        __typename: "MetadataColumns",
        comment?: string | null,
        description?: string | null,
        identifier?: IdentifierType | null,
        name?: string | null,
        parameters?: string | null,
        type?: string | null,
      } > | null,
      dataConnectionId?: string | null,
      database_name?: string | null,
      datasource_name?: string | null,
      row_count?: string | null,
      sync_status?: SyncStatus | null,
      table_name?: string | null,
    } > | null,
    status?: EngagementStatus | null,
  } | null > | null,
};

export type GetEntitlementsQueryVariables = {
  role: string,
};

export type GetEntitlementsQuery = {
  GetEntitlements?:  {
    __typename: "Entitlements",
    entitlements?: Array< string > | null,
    role?: string | null,
  } | null,
};

export type GetExportAudiencesQueryVariables = {
  engagementId: string,
};

export type GetExportAudiencesQuery = {
  GetExportAudiences?:  Array< {
    __typename: "ExportAudience",
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    attributesMapping?: string | null,
    audienceFrom?: AudienceType | null,
    channelId?: string | null,
    engagement: string,
    expireAt?: string | null,
    exportId: string,
    exportStatus?: ExportStatus | null,
    exportedAt?: string | null,
    exportedBy?: string | null,
    fileType?: FileType | null,
    folderPath?: string | null,
    orgType?: string | null,
    queryId?: string | null,
    queryName?: string | null,
    rejectReason?: string | null,
    targetChannel?: AllowedChannel | null,
  } | null > | null,
};

export type GetHealthQueryVariables = {
};

export type GetHealthQuery = {
  GetHealth:  {
    __typename: "HealthResponse",
    status: string,
  },
};

export type GetModelQueryVariables = {
  engagementId: string,
  modelId: string,
};

export type GetModelQuery = {
  GetModel?:  {
    __typename: "Model",
    athenaExecutionId: string,
    createdAt?: string | null,
    createdBy?: string | null,
    engagement: string,
    images?: Array< string > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    lookalikeNumber?: number | null,
    maxLookalikeNumber?: number | null,
    metadata?: string | null,
    modelId: string,
    modelType?: ModelType | null,
    name?: string | null,
    orgType?: string | null,
    parentId?: string | null,
    queryId: string,
    queryName?: string | null,
    seedAudienceSize?: number | null,
    status?: ModelStatus | null,
  } | null,
};

export type GetModelsQueryVariables = {
  engagementId: string,
};

export type GetModelsQuery = {
  GetModels?:  Array< {
    __typename: "Model",
    athenaExecutionId: string,
    createdAt?: string | null,
    createdBy?: string | null,
    engagement: string,
    images?: Array< string > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    lookalikeNumber?: number | null,
    maxLookalikeNumber?: number | null,
    metadata?: string | null,
    modelId: string,
    modelType?: ModelType | null,
    name?: string | null,
    orgType?: string | null,
    parentId?: string | null,
    queryId: string,
    queryName?: string | null,
    seedAudienceSize?: number | null,
    status?: ModelStatus | null,
  } > | null,
};

export type GetOrganizationsQueryVariables = {
};

export type GetOrganizationsQuery = {
  GetOrganizations?:  Array< {
    __typename: "Organization",
    isDatabricksConnectionAllowed?: boolean | null,
    orgName: string,
    orgType: OrgType,
    s3Bucket?: string | null,
  } > | null,
};

export type GetPartnerEmailsQueryVariables = {
  collaborationRequest: PartnerEmailInput,
};

export type GetPartnerEmailsQuery = {
  GetPartnerEmails:  {
    __typename: "PartnerEmailResponse",
    data?:  {
      __typename: "PartnerEmailsData",
      admins?: Array< string > | null,
      email: string,
      name: string,
      orgType: string,
    } | null,
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type GetPreSignedUrlQueryVariables = {
  input?: PreSignedUrl | null,
};

export type GetPreSignedUrlQuery = {
  GetPreSignedUrl?:  {
    __typename: "PreSignedUrlResponse",
    deleteUrl?: string | null,
    error?: string | null,
    putUrl?: string | null,
    statusCode?: number | null,
  } | null,
};

export type GetQueryRecordQueryVariables = {
  engagementId: string,
  queryId: string,
};

export type GetQueryRecordQuery = {
  GetQueryRecord?:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  } | null,
};

export type GetQueryRecordsQueryVariables = {
  engagementId: string,
  filterAggregateWithoutQueryProjection?: boolean | null,
};

export type GetQueryRecordsQuery = {
  GetQueryRecords?:  Array< {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  } | null > | null,
};

export type GetRolesQueryVariables = {
};

export type GetRolesQuery = {
  GetRoles:  Array< {
    __typename: "Entitlements",
    entitlements?: Array< string > | null,
    role?: string | null,
  } >,
};

export type GetSecretesPhraseQueryVariables = {
};

export type GetSecretesPhraseQuery = {
  GetSecretesPhrase: string,
};

export type GetSyntheticResultQueryVariables = {
  resultRequest?: AggregateResultRequest | null,
};

export type GetSyntheticResultQuery = {
  GetSyntheticResult?:  {
    __typename: "AggregateResultResponse",
    headers?: Array< string > | null,
    rows?: string | null,
    total?: number | null,
  } | null,
};

export type ValidateQueryRecordQueryVariables = {
  queryRecord: QueryRecordRequest,
};

export type ValidateQueryRecordQuery = {
  ValidateQueryRecord?:  {
    __typename: "ValidationMessageResponse",
    message?: string | null,
    statusCode?: number | null,
    success?: boolean | null,
  } | null,
};

export type OnDataConnectionCreationSubscriptionVariables = {
};

export type OnDataConnectionCreationSubscription = {
  onDataConnectionCreation?:  {
    __typename: "NotifyDataConnectionCreationResponse",
    body?:  {
      __typename: "NotifyDataConnectionCreationBody",
      connectionId?: string | null,
      message?: string | null,
    } | null,
    statusCode?: number | null,
  } | null,
};

export type OnDataConnectionTestSubscriptionVariables = {
};

export type OnDataConnectionTestSubscription = {
  onDataConnectionTest?:  {
    __typename: "NotifyDataConnectionTestResponse",
    connectionId?: string | null,
    message?: string | null,
    status?: string | null,
    statusCode?: number | null,
  } | null,
};

export type OnExecutionUpdateQueryRecordsSubscriptionVariables = {
  engagement: string,
};

export type OnExecutionUpdateQueryRecordsSubscription = {
  onExecutionUpdateQueryRecords?:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  } | null,
};

export type OnModelUpdateSubscriptionVariables = {
};

export type OnModelUpdateSubscription = {
  onModelUpdate:  {
    __typename: "Response",
    data?:  {
      __typename: "Model",
      athenaExecutionId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      engagement: string,
      images?: Array< string > | null,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      lookalikeNumber?: number | null,
      maxLookalikeNumber?: number | null,
      metadata?: string | null,
      modelId: string,
      modelType?: ModelType | null,
      name?: string | null,
      orgType?: string | null,
      parentId?: string | null,
      queryId: string,
      queryName?: string | null,
      seedAudienceSize?: number | null,
      status?: ModelStatus | null,
    } | null,
    statusCode?: number | null,
    statusMessage?: string | null,
    success: boolean,
  },
};

export type OnNotifyJobCompleteSubscriptionVariables = {
  jobId?: string | null,
};

export type OnNotifyJobCompleteSubscription = {
  onNotifyJobComplete?:  {
    __typename: "NotifyJobCompleteType",
    body?:  {
      __typename: "AiQueryGeneratedBody",
      aiComments?: string | null,
      generatedSql?: string | null,
      jobId?: string | null,
      status?: string | null,
      updatedAt?: string | null,
    } | null,
    jobId?: string | null,
    statusCode?: number | null,
  } | null,
};

export type OnUpdateQueryRecordsSubscriptionVariables = {
  engagement: string,
};

export type OnUpdateQueryRecordsSubscription = {
  onUpdateQueryRecords?:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  } | null,
};

export type OnValidateQueryRecordsSubscriptionVariables = {
  engagement: string,
};

export type OnValidateQueryRecordsSubscription = {
  onValidateQueryRecords?:  {
    __typename: "QueryRecord",
    CSVKey?: string | null,
    approvalStatus?: ApprovalStatus | null,
    approvedBy?: string | null,
    athenaExecutionId?: string | null,
    createdAt?: string | null,
    createdBy?: string | null,
    description?: string | null,
    engagement: string,
    executionDuration?: number | null,
    executionEndTime?: string | null,
    executionStartTime?: string | null,
    executionStatus?: ExecutionStatus | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    metadata?: string | null,
    metadataKey?: string | null,
    name?: string | null,
    orgType?: string | null,
    query?: string | null,
    queryId: string,
    rejectReason?: string | null,
    syntheticResult?: SyntheticResultStatus | null,
    type?: QueryType | null,
    validationLogs?: string | null,
    validationStatus?: Status | null,
  } | null,
};
